<template>
    <div id="notifications-component">
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="row ">
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                        <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                      v-model="pagination.current_page" :total-rows="pagination.total"
                                      :per-page="pagination.per_page" aria-controls="my-table"
                                      v-on:change="onChange"></b-pagination>
                    </div>
                    <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                        <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                               placeholder="Buscar por palabra">
                        <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                    </div>
                    <div class="col-12  col-xl-2 mb-3 mb-sm-0 cont_select">
                        <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="30">30</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>
                    </div>
                </div>
            </div>
            <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy" :items="pagination.data"
                     :filter="filter">
                <template #head(Acciones)="{item}">
                    <i class="fa-solid fa-gear"></i>
                </template>
                <template #cell(notificacion)="{item}">
                    <span v-html="item.data.message"></span>
                </template>
                <template #cell(fecha)="{item}">
                    {{ item.created_at | formatoFecha }}
                </template>
                <template #cell(status)="{item}">
                    <span v-if="item.read_at==null" class="badge rounded-pill text-bg-danger">No leida</span>
                    <span v-else class="badge rounded-pill text-bg-green">Leida</span>
                </template>
                <template #cell(acciones)="{item}">
                    <span v-if="kind_not==='unread'">
                        <button type="button" class="btn btn-outline-secondary"
                                v-on:click="markAsRead(item.id)">Leida</button>
                    </span>
                </template>
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                    </div>
                </template>
            </b-table>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {notificationsService} from "../../Services/Notifications.service";

export default {
    name: "notifications",
    mixins: [myMixins],
    props: {
        kind_not: {
            type: String,
            default: 0
        },
        id_reg: {
            type: Number,
            default: 0
        },

    },
    data() {
        return {
            filter: null,
            isBusy: false,
            params: {
                limit: 10,
                page: 1,
                where: [{
                    field: 'notifiable_id',
                    operator: '=',
                    value: this.id_reg
                }]
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'notificacion'},
                {key: 'fecha'},
                {key: 'status'},
                {key: 'acciones'},
            ],

        }
    },
    methods: {
        async index() {
            this.isBusy = true;

            switch (this.kind_not) {
                case 'all':
                    this.pagination = await notificationsService.allNotifications(this.params);
                    break;
                case 'unread':
                    this.pagination = await notificationsService.unreadNotifications(this.params);
                    break;
                case 'read':
                    this.pagination = await notificationsService.readNotifications(this.params);
                    break;
            }

            this.isBusy = false;
        },
        async markAsRead(id) {
            let resp = await notificationsService.markAsRead(id);
            this.getAlert(resp.process);
            await this.index();
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
    },
    filters: {
        formatoFecha(valor) {
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                timeZoneName: 'short'
            };
            return new Date(valor).toLocaleDateString('es-ES', options);
        }
    },
    mounted() {
        this.index();
    }
}
</script>

